module.exports = __webpack_public_path__ + "media/images/slider-img-03-dde9394eece1680767b9b02f34164258.jpg";